module.exports = __webpack_public_path__ + "5bfac9518d0ce32463b81180079a1b1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/jude.png
// module id = 1508
// module chunks = 0